import { infoColor } from "./status/info.js";
const info = (mode)=>{
    const color = infoColor(mode);
    return {
        main: color.main,
        light: 'light' === mode ? color.lowContrast : color.highContrast,
        dark: 'light' === mode ? color.highContrast : color.lowContrast
    };
};
export { info };

//# sourceMappingURL=info.js.map